import sound from "../config/game.js";
import { Howl } from "howler";

//获取BGM key
const bgmKey = ["hallBgm", "roomBgm"];

//BGM音量,音效音量,BGM开关,音效开关
const lsKey = [
    "volume_music",
    "volume_effect",
    "switch_music",
    "switch_effect",
];

class soundManager {
    soundEffectInstance = null; //音效
    soundBgmInstance = null; //BGM
    constructor() {}
    playBgm(gameID, key = 0, autoplay = false, loop = true) {
        //播放BGM，只允许存在一个
        if (this.soundBgmInstance != null) {
            this.soundBgmInstance.unload();
            this.soundBgmInstance = null;
        }
        const sounds = this.getSounds(gameID, key);
        if (sounds.length > 0) {
            this.soundBgmInstance = new Howl({
                src: sounds,
                autoplay: autoplay,
                loop: loop,
                volume: this.getBgmSoundsVolume(),
            });
            if (!window.isBackground && this.getBgmSoundsStatus() == 1) {
                this.soundBgmInstance.play();
            }
        }
    }
    unloadBgm() {
        //停止BGM
        if (this.soundBgmInstance != null) {
            this.soundBgmInstance.unload();
            this.soundBgmInstance = null;
        }
    }
    pauseBgm() {
        //切换后台时暂停BGM
        if (this.soundBgmInstance != null) {
            this.soundBgmInstance.pause();
        }
    }
    recoverBGM() {
        //恢复BGM
        if (this.soundBgmInstance != null) {
            if (this.soundBgmInstance.playing() || window.isBackground) {
                return;
            }
            if (this.getBgmSoundsStatus() == 1) {
                this.soundBgmInstance.play();
            }
        }
    }
    playEffect(gameID, key = 0, autoplay = false, loop = false) {
        if (this.soundEffectInstance != null) {
            this.soundEffectInstance.unload();
            this.soundEffectInstance = null;
        }
        const sounds = this.getSounds(gameID, key);
        if (sounds.length > 0) {
            this.soundEffectInstance = new Howl({
                src: sounds,
                autoplay: autoplay,
                loop: loop,
                volume: this.getEffectSoundsVolume(),
            });
            if (this.getEffectSoundsStatus() == 1) {
                this.soundEffectInstance.play();
            }
        }
    }
    getBgmSoundsVolume() {
        const volumeMusic = localStorage.getItem(lsKey[0]);
        if (volumeMusic != null) {
            return volumeMusic;
        } else {
            return 0.5;
        }
    }
    getEffectSoundsVolume() {
        const volumeMusic = localStorage.getItem(lsKey[1]);
        if (volumeMusic != null) {
            return volumeMusic;
        } else {
            return 0.8;
        }
    }
    getBgmSoundsStatus() {
        const volumeMusic = localStorage.getItem(lsKey[2]);
        if (volumeMusic != null) {
            return volumeMusic;
        } else {
            localStorage.setItem(lsKey[2], 1);
            return 1;
        }
    }
    getEffectSoundsStatus() {
        const volumeMusic = localStorage.getItem(lsKey[3]);
        if (volumeMusic != null) {
            return volumeMusic;
        } else {
            localStorage.setItem(lsKey[3], 1);
            return 1;
        }
    }
    getSounds(gameID, key) {
        //get Sounds by gameID
        let sounds = [];
        if (typeof key == "string") {
            if (["luckyWheel"].includes(key)) {
                for (let i = 0; i < sound.length; i++) {
                    for (let item in sound[i]) {
                        if (item == key) {
                            sounds.push(sound[i][key]);
                            break;
                        }
                    }
                }
            } else {
                for (let i = 0; i < sound.length; i++) {
                    for (let item in sound[i]) {
                        if (item == key && sound[i]["gameID"] == gameID) {
                            sounds.push(sound[i][key]);
                            break;
                        }
                    }
                }
            }
        }
        if (sounds.length == 0) {
            for (let i = 0; i < sound.length; i++) {
                if (sound[i].gameID == gameID) {
                    key = typeof key == "number" ? bgmKey[key] : key;
                    sounds.push(sound[i][key]);
                    break;
                }
            }
        }
        return sounds;
    }
    muteAll(val) {
        //音效+BGM是否静音
        this.effectMute(val);
        this.bgmMute(val);
    }
    effectMute(val) {
        //音效是否静音
        if (this.soundEffectInstance != null) {
            this.soundEffectInstance.mute(val);
        }
    }
    bgmMute(val) {
        //BGM是否静音
        if (this.soundBgmInstance != null) {
            this.soundBgmInstance.mute(val);
        }
    }
    setBgmVolume(num) {
        //改变BGM音量大小(0.0 to 1.0)
        const val = num / 100;
        localStorage.setItem(lsKey[0], val);
        if (this.soundBgmInstance != null) {
            this.soundBgmInstance.volume(val);
        }
    }
    setEffectVolume(num) {
        const val = num / 100;
        //改变音效大小(0.0 to 1.0)
        localStorage.setItem(lsKey[1], val);
    }
    setBgmStatus(status) {
        //设置背景音乐开关,1为启用；0为关闭
        localStorage.setItem(lsKey[2], status);
        if (status == 1) {
            if (this.soundBgmInstance != null && !this.soundBgmInstance.playing()) {
                this.soundBgmInstance.play();
            }
        } else {
            if (this.soundBgmInstance != null && this.soundBgmInstance.playing()) {
                this.soundBgmInstance.pause();
            }
        }
    }
    setEffectStatus(status) {
        //设置音效开关,1为启用；0为关闭
        localStorage.setItem(lsKey[3], status);
    }
}

export default soundManager;